export const SUPERRESOLUTION='SUPERRESOLUTION' 
export const IMAGECLASSIFICATION='IMAGECLASSIFICATION' 
export const FACESIMILARITY='FACESIMILARITY' 
